import styles from './loginForm.module.css'
import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
function LoginForm({ onLogin }) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        try {
            const response = await fetch('/api/auth/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password }),
            });

            if (!response.ok) {
                const { message } = await response.json();
                return setError(message || 'Login fehlgeschlagen');
            }

            const data = await response.json();
            localStorage.setItem('token', data.token);

            navigate('/admin/panel'); // ✅ redirect to Admin Panel
        } catch (err) {
            console.error(err);
            setEmail("")
            setPassword("")
            setError('Password oder E-Mail falsch');
        }
    };
    return (
        <div className={styles.container}>
            <h2>Login</h2>
            <form onSubmit={handleSubmit} className={styles.form}>
                <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className={styles.input}
                />
                <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    className={styles.input}
                />
                {error && <p className={styles.error}>{error}</p>}
                <button type="submit" className={styles.button}>Login</button>
            </form>
            <Link to="/admin/forgot-password" className={styles.link}>Passwort vergessen?</Link>
        </div>
    );
}

export default LoginForm
